import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const BasicEcommerceTemplate = ({
  height = 80,
  width = 72,
  color = colors.white,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} {...props}>
    <rect width="71.1111" height="80" rx="4" fill={getColor(color, isColorInherited)} />
    <rect
      x="7.86108"
      y="24.75"
      width="24.2778"
      height="12.7222"
      rx="1.25"
      stroke="#E0DEDF"
      strokeWidth="1.5"
    />
    <rect
      x="38.9722"
      y="24.75"
      width="24.2778"
      height="12.7222"
      rx="1.25"
      stroke="#E0DEDF"
      strokeWidth="1.5"
    />
    <line
      x1="8.11108"
      y1="9.66675"
      x2="63"
      y2="9.66675"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="8.11108"
      y1="16.7778"
      x2="63"
      y2="16.7778"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="8.11108"
      y1="44.3333"
      x2="31.8889"
      y2="44.3333"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="39.2222"
      y1="44.3333"
      x2="62.9999"
      y2="44.3333"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <rect
      x="7.86108"
      y="51.4167"
      width="24.2778"
      height="12.7222"
      rx="1.25"
      stroke="#E0DEDF"
      strokeWidth="1.5"
    />
    <rect
      x="38.9722"
      y="51.4167"
      width="24.2778"
      height="12.7222"
      rx="1.25"
      stroke="#E0DEDF"
      strokeWidth="1.5"
    />
    <line
      x1="8.11108"
      y1="71"
      x2="31.8889"
      y2="71"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="39.2222"
      y1="71"
      x2="62.9999"
      y2="71"
      stroke="#E0DEDF"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </SvgIcon>
);
